import {
    setDay,
    isSunday,
    addDays,
    subDays,
    startOfDay,
    startOfWeek,
    startOfMonth,
    endOfMonth,
    subMonths,
    endOfWeek,
    subWeeks,
    startOfYear,
    endOfYear,
    subYears,
    format,
    parse,
    endOfDay,
    addMonths
} from 'date-fns';
import {
    IListItem,
    IChartPeriod,
    IChartPeriodStr,
    ChartGroupBy
} from '@/entities';
import { formatDate, nowEDT } from '.';
const DATE_FORMAT = 'YYYY-MM-DD';

export function createChartPeriodListItems(): IListItem[] {
    const res = [];
    const now = nowEDT();
    const weekStart = startOfWeek(now);
    const monthStart = startOfMonth(now);
    const yearStart = startOfYear(now);

    // days

    res.push(
        createChartPeriodItem(
            subDays(now, 7),
            now,
            ChartGroupBy.day,
            'Last 12 days'
        )
    );
    res.push(
        createChartPeriodItem(
            weekStart,
            endOfWeek(weekStart),
            ChartGroupBy.day,
            'This week'
        )
    );
    res.push(
        createChartPeriodItem(
            subWeeks(weekStart, 1),
            endOfWeek(subWeeks(weekStart, 1)),
            ChartGroupBy.day,
            'Prev week'
        )
    );
    res.push(
        createChartPeriodItem(
            monthStart,
            endOfMonth(monthStart),
            ChartGroupBy.day,
            'This month'
        )
    );
    res.push(
        createChartPeriodItem(
            subMonths(monthStart, 1),
            endOfMonth(subMonths(monthStart, 1)),
            ChartGroupBy.day,
            'Prev month'
        )
    );
    res.push(
        createChartPeriodItem(
            yearStart,
            endOfYear(yearStart),
            ChartGroupBy.month,
            'This year'
        )
    );
    res.push(
        createChartPeriodItem(
            subYears(yearStart, 1),
            endOfYear(subYears(yearStart, 1)),
            ChartGroupBy.month,
            'Prev year'
        )
    );
    return res;
}

export function parseChartPeriodListItem(str: string): IChartPeriod {
    const splits = str.split(',');
    return {
        start: parse(splits[0]),
        end: parse(splits[1]),
        groupBy: splits[2] as ChartGroupBy
    };
}

export function toStrChartPeriod(period: IChartPeriod): IChartPeriodStr {
    return {
        start: formatDate(period.start),
        end: formatDate(period.end),
        groupBy: period.groupBy
    };
}

function createChartPeriodItem(
    start: Date,
    end: Date,
    groupBy: ChartGroupBy,
    title: string
): IListItem {
    const period = {
        start: startOfDay(start),
        end: endOfDay(end),
        groupBy
    };
    return {
        value: periodToStr(period),
        heading: title
    };
}

function periodToStr(period: IChartPeriod): string {
    return (
        format(period.start, DATE_FORMAT) +
        ',' +
        format(period.end, DATE_FORMAT) +
        ',' +
        period.groupBy
    );
}
